import { render } from "./ErequisitionView.vue?vue&type=template&id=364139d8&scoped=true"
import script from "./ErequisitionView.vue?vue&type=script&lang=js"
export * from "./ErequisitionView.vue?vue&type=script&lang=js"

import "./ErequisitionView.vue?vue&type=style&index=0&id=364139d8&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-364139d8"],['__file',"src/components/cases/ErequisitionView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "364139d8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('364139d8', __exports__)) {
    console.log('reload')
    api.reload('364139d8', __exports__)
  }
  
  module.hot.accept("./ErequisitionView.vue?vue&type=template&id=364139d8&scoped=true", () => {
    console.log('re-render')
    api.rerender('364139d8', render)
  })

}


export default __exports__